import { useContext } from 'react';
import AppContext from '../../../AppContext';
import RatioFormat from '../../format/RatioFormat';
import PointFormat from '../../format/PointFormat';
import AnnualChangeRowProps from './AnnualChangeRowProps';
import { renderYearValueAsRatio } from './yearRenderUtils';
import useTableauEmbedScript from './useTableauEmbedScript';
import styles from './RatioRow.module.css';

interface RatioRowProps extends AnnualChangeRowProps {
  isVizExpanded?: boolean;
}

export default function RatioRow({
  data,
  showPercentPointChange,
  isVizExpanded = true
}: RatioRowProps) {
  const { activeYearsMode, cocode, year } = useContext(AppContext);
  const showTenYearCells = activeYearsMode === 'TEN' && data.priorYearMinusFour !== undefined;
  const currentYearIsNA = data.currentYear?.showAsNA === true;
  const tableauDashboardUrl = data.embeddedDashboardUrl;
  useTableauEmbedScript(tableauDashboardUrl);

  return (
    <>
      {showPercentPointChange ? (
        <PointFormat {...data.percentOrPointChange} showDefaultValue={true} />
      ) : (
        <p></p>
      )}
      <p></p>
      {currentYearIsNA ? (
        <p></p>
      ) : (
        <RatioFormat
          {...(data.percentOfPHS?.value ? { ...data.percentOfPHS } : data.percentOfCAS ? { ...data.percentOfCAS } : {})}
        />
      )}
      {currentYearIsNA ? (
        <p></p>
      ) : (
        <RatioFormat {...data.percentOfNAA} />
      )}
      <RatioFormat {...data.industryMean} />
      {renderYearValueAsRatio(data.currentYear)}
      {renderYearValueAsRatio(data.priorYear)}
      {renderYearValueAsRatio(data.priorYearMinusOne)}
      {renderYearValueAsRatio(data.priorYearMinusTwo)}
      {renderYearValueAsRatio(data.priorYearMinusThree)}
      {showTenYearCells && (
        <>
          {renderYearValueAsRatio(data.priorYearMinusFour as any)}
          {renderYearValueAsRatio(data.priorYearMinusFive as any)}
          {renderYearValueAsRatio(data.priorYearMinusSix as any)}
          {renderYearValueAsRatio(data.priorYearMinusSeven as any)}
          {renderYearValueAsRatio(data.priorYearMinusEight as any)}
        </>
      )}
      {tableauDashboardUrl?.trim() && isVizExpanded && (
        <div className={styles.tableauContainer}>
          <tableau-viz
            id="tableau-viz"
            src={tableauDashboardUrl}
            width="1400"
            hide-tabs
            toolbar="bottom"
          >
            <viz-parameter name="COCODE" value={cocode} />
            <viz-parameter name="YEAR" value={year} />
          </tableau-viz>
        </div>
      )}
    </>
  );
}
